// extracted by mini-css-extract-plugin
module.exports = {"title":"e_Bi","container":"e_Ci","right":"e_Di","image":"e_Ei","scoreLine":"e_Fi","scoreRing":"e_Gi","badge":"e_Hi","badgeImage":"e_Ii","badgeRing":"e_Ji","large":"e_Ki"};